module.exports = __webpack_public_path__ + "static/img/homepage-bg-md.934d960.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-bg-md.svg
// module id = K/Wd
// module chunks = 2